var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Tab } from './components/tab/tab';
import * as styles from './tab-list.styles';
import { classNames } from '../../utils';
export var TabList = function (_a) {
    var id = _a.id, tabItems = _a.tabItems, tabSelected = _a.tabSelected, setSelectedIndex = _a.setSelectedIndex, className = _a.className, tabClassName = _a.tabClassName;
    var _b = useState(0), activeTabIndex = _b[0], setActiveIndexTab = _b[1];
    var _c = useState(), activeTabItem = _c[0], setActiveTabItem = _c[1];
    useEffect(function () {
        if (tabItems != null) {
            if (tabItems.length > 0) {
                var currentActiveTab = tabItems.findIndex(function (x) { return x.initActive === true; });
                if (currentActiveTab !== -1) {
                    setActiveIndexTab(currentActiveTab);
                    setActiveTabItem(tabItems[currentActiveTab]);
                }
            }
        }
    }, []);
    useEffect(function () {
        if (setSelectedIndex !== undefined) {
            setActiveIndexTab(setSelectedIndex);
            setActiveTabItem(tabItems[setSelectedIndex]);
            setSelectedTab(tabItems[setSelectedIndex], setSelectedIndex);
        }
    }, [setSelectedIndex]);
    var setSelectedTab = function (tab, tabIndex) {
        setActiveIndexTab(tabIndex);
        setActiveTabItem(tab);
        if (tabSelected)
            tabSelected(tab, tabIndex);
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ id: id, className: classNames(styles.tabScrollBar, className) }, { children: _jsx("div", { children: _jsx("div", __assign({ className: styles.navContainer }, { children: _jsx("nav", __assign({ className: styles.navStyle, "aria-label": "Tabs" }, { children: tabItems.length === 1 ? (_jsx(Tab, { className: classNames(styles.fullWidth, tabClassName), title: tabItems[0].title, tabIndex: 0, activeIndex: 0, isOnlyTab: true })) : (tabItems.map(function (item, index) {
                                return (_jsx(Tab, { className: classNames('text-textDark font-medium', tabClassName), title: item.title, tabIndex: index, activeIndex: activeTabIndex, tabSelected: function (idx) { return setSelectedTab(item, idx); } }, index));
                            })) })) })) }) })), activeTabItem && activeTabItem.child] }));
};
export default TabList;
//# sourceMappingURL=tab-list.js.map